import { ConstructionComponentInfo } from "@interfaces/constructor/constructor";
import { ComponentType } from "react";
import DailyGift from "./dailyGift";
import DailyGiftDays from "./dailyGiftDays";
import DailyGiftItemCount from "./dailyGiftItemCount";
import DailyGiftName from "./dailyGiftName";
import DailyGiftReceive from "./dailyGiftReceive";
import DailyGiftsList from "./dailyGiftsList";

const DailyGiftInfo: ConstructionComponentInfo = {
    component: DailyGift,
    requiredParent: [
        'DailyGiftsList'
    ]
}

const DailyGiftNameInfo: ConstructionComponentInfo = {
    component: DailyGiftName,
    requiredParent: [
        'DailyGiftsList'
    ]
}

const DailyGiftItemCountInfo: ConstructionComponentInfo = {
    component: DailyGiftItemCount,
    requiredParent: [
        'DailyGift'
    ]
}

const DailyGiftDaysInfo: ConstructionComponentInfo = {
    component: DailyGiftDays,
    requiredParent: [
        'DailyGiftsList'
    ]
}

const DailyGiftsListInfo: ConstructionComponentInfo = {
    component: DailyGiftsList as ComponentType,
    injectChild: [
        'slider_ref'
    ]
}

const DailyGiftReceiveInfo: ConstructionComponentInfo = {
    component: DailyGiftReceive
}

export {
    DailyGiftInfo,
    DailyGiftNameInfo,
    DailyGiftItemCountInfo,
    DailyGiftDaysInfo,
    DailyGiftsListInfo,
    DailyGiftReceiveInfo
}
